// 女神漫画首页 Mock 数据

export const headerNav = [
  { label: '人气榜单', anchor: '#ranking' },
  { label: '阅读优势', anchor: '#features' },
  { label: '移动畅读', anchor: '#app' },
  { label: '精选推荐', anchor: '#carousel' },
];

export const heroData = {
  tag: '🔥 全网热门漫画一站式收录',
  h1: '女神漫画 · 韩漫日漫国漫热门推荐平台',
  slogan: '下拉式阅读 · 免费全集 · 追更收藏',
  intro: '女神漫画是国内领先的在线漫画阅读平台，专注收录韩漫、日漫、国漫三大品类热门作品。每日更新大量正版漫画资源，提供流畅的下拉式阅读体验，支持一键追更与云端收藏。无论你偏爱恋爱甜宠、奇幻冒险还是悬疑推理，这里都能找到属于你的那本漫画。当前平台已覆盖超过 2000+ 部热门连载作品，每周新增 50+ 部新作上架，韩漫与国漫分类持续扩充中。',
  stats: [
    { value: '2,000+', label: '热门连载' },
    { value: '50+', label: '每周上新' },
    { value: '99.9%', label: '稳定在线' },
  ],
  primaryCta: { label: '开始阅读', anchor: '#ranking' },
  secondaryCta: { label: '下载APP', anchor: '#app' },
};

export const appData = [
  {
    title: '女神漫画 APP · 随时随地畅享阅读',
    description: '专为移动端优化的下拉式阅读引擎，支持离线缓存、夜间模式、书签同步。iOS 与 Android 双端覆盖，安装即享完整漫画大全。',
    features: ['下拉式阅读', '离线缓存', '夜间模式', '云端同步', '推送追更提醒'],
    qrLabel: '扫码下载 APP',
  },
];

export const topicsData = [
  { name: '韩漫热榜', heat: '128万', slug: 'korean-hot', color: 'primary' },
  { name: '日漫经典', heat: '96万', slug: 'japanese-classic', color: 'accent' },
  { name: '国漫崛起', heat: '83万', slug: 'chinese-rise', color: 'secondary' },
  { name: '恋爱甜宠', heat: '75万', slug: 'romance', color: 'primary' },
  { name: '奇幻冒险', heat: '68万', slug: 'fantasy', color: 'accent' },
  { name: '悬疑推理', heat: '61万', slug: 'mystery', color: 'secondary' },
  { name: '动作热血', heat: '57万', slug: 'action', color: 'primary' },
  { name: '日常治愈', heat: '52万', slug: 'slice-of-life', color: 'accent' },
  { name: '耽美专区', heat: '49万', slug: 'bl', color: 'secondary' },
  { name: '搞笑沙雕', heat: '44万', slug: 'comedy', color: 'primary' },
  { name: '恐怖惊悚', heat: '38万', slug: 'horror', color: 'accent' },
];

export const rankingData = [
  { rank: 1, title: '某天成为公主', author: 'Spoon / Plutus', genre: '韩漫·恋爱', status: '连载中', heat: '256万', desc: '穿越成小说中的悲情公主，用智慧与魅力改写命运。画风精致唯美，剧情甜中带虐，长期霸占韩漫热榜前三。' },
  { rank: 2, title: '我独自升级', author: 'Chugong / DUBU', genre: '韩漫·动作', status: '已完结', heat: '241万', desc: '全球最弱猎人觉醒逆天升级系统，从底层一步步登上巅峰。打斗场面炸裂，世界观宏大，现象级韩漫代表。' },
  { rank: 3, title: '鬼灭之刃', author: '吾峠呼世晴', genre: '日漫·热血', status: '已完结', heat: '228万', desc: '少年灶门炭治郎为救妹妹踏上斩鬼之旅，感动千万读者的王道热血传奇。' },
  { rank: 4, title: '镖人', author: '许先哲', genre: '国漫·武侠', status: '连载中', heat: '195万', desc: '硬核武侠国漫之光，大漠刀客刀马的江湖传奇。分镜与画功堪称国产天花板，海外发行多国语言。' },
  { rank: 5, title: '反派千金', author: 'Midori / Yunsul', genre: '韩漫·穿越', status: '连载中', heat: '182万', desc: '转生为注定灭亡的反派千金，利用现代知识逆天改命。剧情反转不断，角色塑造鲜活，读者好评如潮。' },
  { rank: 6, title: '咒术回战', author: '芥见下下', genre: '日漫·战斗', status: '连载中', heat: '176万', desc: '咒术师对抗诅咒的热血物语，复杂的能力体系与震撼的战斗刻画，当今少年Jump台柱之一。' },
  { rank: 7, title: '狐妖小红娘', author: '小新', genre: '国漫·玄幻', status: '连载中', heat: '163万', desc: '以红线仙涂山苏苏为主角的人妖情缘故事，细腻的情感描绘与唯美国风画面完美融合。' },
];

export const mediaData = [
  { title: '韩漫入门必读TOP10', cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20fantasy%20illustration%2C%20beautiful%20princess%20character%20in%20elegant%20dress%2C%20soft%20pastel%20warm%20tones%2C%20delicate%20linework%2C%20manhwa%20cover%20aesthetic%2C%20ornamental%20border%20design%2C%20dreamy%20atmosphere%2C%20editorial%20manga%20art%20style%2C%20clean%20composition&width=400&height=560&seq=manga-media-01&orientation=portrait', tag: '入门指南', views: '86万' },
  { title: '日漫神作一口气看完', cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20action%20scene%20with%20samurai%20and%20demon%20characters%2C%20dynamic%20composition%2C%20ink%20wash%20painting%20influence%2C%20warm%20amber%20and%20crimson%20color%20palette%2C%20detailed%20lineart%2C%20dramatic%20lighting%2C%20manga%20volume%20cover%20design%2C%20clean%20simple%20background&width=400&height=560&seq=manga-media-02&orientation=portrait', tag: '完结推荐', views: '72万' },
  { title: '国漫崛起代表作盘点', cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20fantasy%20illustration%2C%20ancient%20Chinese%20warrior%20in%20flowing%20robes%2C%20ink%20brush%20style%20with%20watercolor%20texture%2C%20warm%20earth%20tones%2C%20elegant%20composition%2C%20traditional%20Chinese%20painting%20aesthetic%20modern%20manhua%20cover&width=400&height=560&seq=manga-media-03&orientation=portrait', tag: '国风精选', views: '65万' },
  { title: '恋爱甜宠漫深夜必看', cover: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20style%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20peach%20color%20palette%2C%20gentle%20atmosphere%2C%20shoujo%20manga%20cover%20aesthetic%2C%20sparkling%20light%20effects%2C%20floating%20petals%2C%20clean%20simple%20background%2C%20sweet%20romantic%20vibe&width=400&height=560&seq=manga-media-04&orientation=portrait', tag: '甜宠必看', views: '59万' },
  { title: '悬疑烧脑漫推理盛宴', cover: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20manga%20illustration%20with%20shadowy%20detective%20figure%2C%20noir%20atmosphere%2C%20warm%20sepia%20and%20deep%20brown%20tones%2C%20rainy%20cityscape%20background%2C%20suspenseful%20mood%2C%20psychological%20manga%20cover%20design%2C%20clean%20typography%20space&width=400&height=560&seq=manga-media-05&orientation=portrait', tag: '烧脑神作', views: '48万' },
];

export const faqData = [
  { q: '女神漫画是否全部免费阅读？', a: '是的！女神漫画平台上的所有作品均提供免费全集阅读。我们通过广告合作与会员增值服务维持运营，确保核心漫画阅读体验完全免费，无需付费解锁章节。部分作品支持高清画质与去广告特权，可通过开通会员获取。' },
  { q: '支持哪些设备阅读漫画？', a: '女神漫画支持 PC 浏览器、iOS 与 Android 手机、平板电脑等多种设备。我们自主研发的下拉式阅读引擎在所有设备上均可流畅运行，并支持横竖屏自适应切换。通过女神漫画 APP 还可享受离线缓存与推送追更提醒功能。' },
  { q: '漫画更新频率如何？', a: '平台与多家正版漫画版权方深度合作，热门连载作品保持与官方同步更新。韩漫每周更新 3-5 话、日漫每周更新 1-2 话、国漫每周更新 2-4 话。每周新增上架作品超 50 部，确保读者总能找到新鲜内容。' },
  { q: '如何收藏与追更喜欢的漫画？', a: '阅读任意漫画时，点击作品详情页的"收藏"按钮即可加入个人书架。收藏后该作品有更新时，平台将通过站内消息与 APP 推送双重提醒。收藏列表支持分类管理与阅读进度同步，换设备也能无缝衔接。' },
  { q: '平台上漫画是否有正版授权？', a: '女神漫画高度重视版权保护，所有上架作品均已获得版权方正式授权。我们与国内外多家知名漫画出版社和创作平台建立了长期合作关系，读者可以放心阅读。同时我们坚决抵制盗版，维护漫画创作者的合法权益。' },
];

export const featuresData = [
  {
    icon: 'ri-file-list-3-line',
    title: '下拉式沉浸阅读',
    desc: '自主研发的纵向无缝滚动阅读引擎，告别翻页打断感，一口气读完一话。支持速度调节与自动滚动，阅读体验流畅如丝。',
  },
  {
    icon: 'ri-bookmark-3-line',
    title: '智能追更与云收藏',
    desc: '收藏即追更，更新即提醒。跨设备云端同步阅读进度与书架，换手机、换平板无缝衔接。支持分类管理超过 500 部收藏作品。',
  },
  {
    icon: 'ri-palette-line',
    title: '海量正版漫画大全',
    desc: '韩漫、日漫、国漫三大品类超过 2000+ 部热门作品，涵盖恋爱、奇幻、悬疑、热血、搞笑等全类型。每周持续上新，总有新发现。',
  },
];

export const commentsData = [
  { name: '樱花飘落时', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%2C%20simple%20warm%20background%2C%20soft%20illustration%20style%2C%20manga%20avatar%20portrait&width=80&height=80&seq=avatar-01&orientation=squarish', content: '女神漫画的下拉式阅读体验真的太舒服了！之前在其他平台翻页翻到手指抽筋，这里直接一滑到底，看韩漫的体验直接拉满。而且更新速度超快，追的几部热门韩漫基本同步官方，强烈推荐！', time: '2天前', likes: 1286 },
  { name: '热血漫爱好者', avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20spiky%20hair%2C%20simple%20warm%20background%2C%20action%20character%20portrait%2C%20manga%20avatar%20style&width=80&height=80&seq=avatar-02&orientation=squarish', content: '作为一个追了十年漫画的老读者，女神漫画的收藏追更功能真的业界良心。云端同步超方便，iPad 上看完手机上继续，进度完全不会乱。排行榜也很靠谱，帮我发现了不少冷门神作。', time: '5天前', likes: 956 },
  { name: '悬疑控本控', avatar: 'https://readdy.ai/api/search-image?query=Elegant%20anime%20style%20woman%20avatar%20with%20dark%20hair%2C%20mysterious%20expression%2C%20simple%20warm%20background%2C%20manga%20avatar%20portrait&width=80&height=80&seq=avatar-03&orientation=squarish', content: '国漫分类做得越来越好了！镖人、狐妖小红娘这些精品国漫都有完整收录，画质高清，翻译也很到位。希望平台能多引进一些悬疑推理类的韩漫，这块作品越来越多了但收录还不够全。', time: '1周前', likes: 723 },
];

export const indexData = [
  { name: '韩漫全集', icon: 'ri-flag-2-line', count: '856部', color: 'primary' },
  { name: '日漫经典', icon: 'ri-earth-line', count: '624部', color: 'accent' },
  { name: '国漫专区', icon: 'ri-map-pin-2-line', count: '512部', color: 'secondary' },
  { name: '恋爱甜宠', icon: 'ri-heart-line', count: '389部', color: 'primary' },
  { name: '奇幻冒险', icon: 'ri-compass-3-line', count: '342部', color: 'accent' },
  { name: '动作热血', icon: 'ri-fire-line', count: '298部', color: 'secondary' },
  { name: '悬疑推理', icon: 'ri-search-eye-line', count: '256部', color: 'primary' },
  { name: '日常治愈', icon: 'ri-sun-line', count: '218部', color: 'accent' },
  { name: '完结神作', icon: 'ri-check-double-line', count: '476部', color: 'secondary' },
];

export const updatesData = [
  { time: '10分钟前', title: '《我独自升级》番外篇更新', desc: '第179话：最终之战·后日谈（上）已上架，番外篇连载开启。', tag: '韩漫·动作' },
  { time: '1小时前', title: '《镖人》最新话上线', desc: '第118话：大漠孤烟直，刀马与知世郎的宿命对决进入高潮。', tag: '国漫·武侠' },
  { time: '3小时前', title: '《某天成为公主》第202话', desc: '希娅公主的成人礼舞会，剧情迎来重大转折，不容错过。', tag: '韩漫·恋爱' },
  { time: '6小时前', title: '《鬼灭之刃》特别篇追加', desc: '无限列车篇导演剪辑版全三话一次性放出，重温炎柱英姿。', tag: '日漫·热血' },
  { time: '昨天', title: '新作上架《反派千金》第二季', desc: '人气穿越韩漫续作回归，全新剧情线与角色登场，首周免费。', tag: '韩漫·穿越' },
  { time: '昨天', title: '《狐妖小红娘》月红篇更新', desc: '涂山红红与东方月初的前世记忆逐步揭开，泪点与甜点齐飞。', tag: '国漫·玄幻' },
  { time: '2天前', title: '《咒术回战》252话上架', desc: '宿傩与五条悟的惊世之战进入白热化，每一格都是视觉盛宴。', tag: '日漫·战斗' },
];

export const carouselData = [
  {
    title: '韩漫巅峰：我独自升级',
    subtitle: '从E级猎人到暗影君主，全球现象级韩漫完整收录',
    image: 'https://readdy.ai/api/search-image?query=Epic%20dark%20fantasy%20manhwa%20scene%20with%20shadow%20warrior%20rising%2C%20dramatic%20purple%20and%20black%20energy%20effects%2C%20powerful%20character%20silhouette%2C%20gates%20and%20dungeons%20in%20background%2C%20Korean%20webtoon%20style%2C%20cinematic%20composition%2C%20warm%20dark%20atmosphere&width=800&height=450&seq=carousel-01&orientation=landscape',
    tag: '韩漫必读',
    desc: '累计阅读量突破 24 亿次，完整收录全 179 话正篇 + 番外，下拉式阅读畅享升级打怪快感。',
  },
  {
    title: '国漫之光：镖人宇宙',
    subtitle: '硬核武侠，国产漫画天花板级别作品',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20desert%20scene%20with%20lone%20swordsman%20riding%20horse%2C%20dramatic%20sunset%20silhouette%2C%20ink%20brush%20painting%20style%2C%20epic%20wuxia%20atmosphere%2C%20warm%20earth%20tones%2C%20cinematic%20wide%20composition%2C%20dust%20and%20wind%20effects&width=800&height=450&seq=carousel-02&orientation=landscape',
    tag: '国漫推荐',
    desc: '许先哲倾力打造，海外发行多国语言版本，分镜与画功堪称国产漫画天花板。',
  },
  {
    title: '日漫经典：鬼灭之刃全收录',
    subtitle: '少年Jump现象级作品，完整漫画体验',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20demon%20slayer%20aesthetic%20scene%20with%20traditional%20Japanese%20elements%2C%20water%20breathing%20visual%20effects%2C%20warm%20crimson%20and%20indigo%20color%20palette%2C%20dynamic%20sword%20action%20composition%2C%20taisho%20era%20atmosphere%2C%20cinematic%20manga%20art%20style&width=800&height=450&seq=carousel-03&orientation=landscape',
    tag: '日漫神作',
    desc: '全 205 话完整收录，无限列车篇导演剪辑版同步上线，一口气重温炭治郎的斩鬼之旅。',
  },
  {
    title: '甜宠专区：恋爱韩漫合集',
    subtitle: '百部高甜恋爱漫，治愈你的每一个夜晚',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20manhwa%20scene%20with%20couple%20in%20flower%20garden%20at%20sunset%2C%20soft%20warm%20pink%20and%20golden%20lighting%2C%20Korean%20webtoon%20romance%20style%2C%20floating%20cherry%20blossoms%2C%20dreamy%20atmosphere%2C%20cinematic%20romantic%20composition%2C%20gentle%20color%20palette&width=800&height=450&seq=carousel-04&orientation=landscape',
    tag: '甜宠合集',
    desc: '《某天成为公主》《反派千金》等百部人气甜宠漫画一站收录，公主系列全齐。',
  },
];

export const contactData = [
  {
    title: '商务合作 & 版权联系',
    items: [
      { icon: 'ri-mail-line', label: '商务邮箱', value: 'business@nvshenmanhua.com' },
      { icon: 'ri-copyright-line', label: '版权合作', value: 'copyright@nvshenmanhua.com' },
      { icon: 'ri-chat-smile-2-line', label: '读者反馈', value: 'feedback@nvshenmanhua.com' },
    ],
    description: '女神漫画欢迎漫画版权方、创作平台与广告合作伙伴洽谈合作。我们提供正版授权收录、联合推广与品牌定制方案，携手共建优质漫画阅读生态。读者如有作品推荐或平台建议，也欢迎通过上方渠道联系我们。',
  },
];

export const cardsData = [
  {
    title: '穿越韩漫：从配角到主角',
    image: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20illustration%20with%20female%20protagonist%20in%20elegant%20medieval%20dress%2C%20magical%20castle%20background%2C%20warm%20golden%20lighting%2C%20romance%20fantasy%20manhwa%20style%2C%20soft%20pastel%20color%20palette%2C%20clean%20composition&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '韩漫·穿越',
    desc: '转生逆袭类韩漫精选合集，从悲情配角到绝对主角的华丽蜕变。',
    count: '127部',
  },
  {
    title: '热血战斗：燃到停不下来',
    image: 'https://readdy.ai/api/search-image?query=Action%20manga%20battle%20scene%20with%20dynamic%20energy%20explosion%20effects%2C%20warrior%20characters%20in%20intense%20combat%2C%20warm%20fire%20and%20amber%20color%20palette%2C%20Japanese%20manga%20action%20style%2C%20speed%20lines%20effects%2C%20cinematic%20composition&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '日漫·热血',
    desc: '拳拳到肉的热血战斗漫合集，每一格都让你肾上腺素飙升。',
    count: '213部',
  },
  {
    title: '国风玄幻：东方美学盛宴',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20manhua%20scene%20with%20ancient%20temple%20and%20floating%20mountains%2C%20immortal%20cultivation%20theme%2C%20ink%20wash%20painting%20style%2C%20warm%20earth%20and%20jade%20green%20tones%2C%20traditional%20Chinese%20aesthetic%2C%20ethereal%20mist%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '国漫·玄幻',
    desc: '仙侠玄幻国漫精选，水墨画风与精彩剧情完美结合，东方美学天花板。',
    count: '198部',
  },
  {
    title: '悬疑推理：烧脑神作合集',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20manga%20scene%20with%20shadowy%20alleyway%20and%20detective%20silhouette%2C%20noir%20atmosphere%2C%20warm%20sepia%20and%20deep%20brown%20tones%2C%20psychological%20suspense%20style%2C%20rain-slicked%20street%2C%20cinematic%20composition&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '日韩·悬疑',
    desc: '高智商对决与细思极恐的悬疑漫精选，反转不断直到最后一页。',
    count: '156部',
  },
  {
    title: '搞笑日常：笑到停不下来',
    image: 'https://readdy.ai/api/search-image?query=Funny%20slice%20of%20life%20manga%20scene%20with%20colorful%20characters%20in%20school%20setting%2C%20comedic%20expressions%2C%20bright%20warm%20color%20palette%2C%20lighthearted%20atmosphere%2C%20Japanese%20comedy%20manga%20style%2C%20clean%20composition&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '日漫·搞笑',
    desc: '轻松治愈的搞笑日常漫合集，减压神器，每一话都让你嘴角上扬。',
    count: '183部',
  },
  {
    title: '完结神作：一口气看到底',
    image: 'https://readdy.ai/api/search-image?query=Completed%20manga%20collection%20aesthetic%20with%20bookshelf%20full%20of%20manga%20volumes%2C%20warm%20cozy%20reading%20nook%2C%20soft%20lighting%2C%20manga%20library%20atmosphere%2C%20clean%20organized%20composition%2C%20warm%20wood%20tones&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '完结精选',
    desc: '已完结高分漫画合集，不用苦等更新，一口气读完完整故事的极致体验。',
    count: '476部',
  },
  {
    title: '最新上架：本周新作速递',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20new%20manga%20releases%20display%20with%20colorful%20cover%20artworks%2C%20modern%20clean%20layout%2C%20warm%20vibrant%20color%20palette%2C%20manga%20promotion%20display%20style%2C%20exciting%20fresh%20atmosphere%2C%20editorial%20composition&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '新作上架',
    desc: '本周新上架作品合集，第一时间发现你的下一部心头好漫画。',
    count: '52部',
  },
];

export const aboutData = [
  {
    title: '关于女神漫画',
    paragraphs: [
      '女神漫画创建于 2023 年，是国内领先的在线漫画阅读与推荐平台。我们致力于为漫画爱好者提供最优质、最全面的漫画大全阅读体验，专注收录韩漫、日漫、国漫三大品类的热门与经典作品。',
      '平台核心特色为自主研发的下拉式阅读引擎，打破传统翻页模式的割裂感，让读者享受一气呵成的沉浸式漫画阅读。同时，智能追更系统与云端收藏功能让漫画爱好者能够轻松管理个人书架，第一时间获取喜爱作品的更新通知。',
      '我们与国内外多家知名漫画出版社和创作平台建立了深度版权合作关系，确保平台上所有作品均为正版授权内容。女神漫画始终坚持"读者至上，品质为先"的运营理念，持续优化阅读体验、扩充内容库、提升服务质量。',
      '无论你是韩漫忠实粉丝、日漫经典爱好者，还是国漫崛起的见证者，女神漫画都将以最丰富的漫画大全、最便捷的阅读方式和最及时的热门推荐，陪伴你的每一段漫画时光。',
    ],
    stats: [
      { value: '2,000+', label: '收录作品' },
      { value: '500万+', label: '月活读者' },
      { value: '99.9%', label: '在线率' },
      { value: '365天', label: '全年无休' },
    ],
  },
];